import gql from 'graphql-tag';
const SAVE_AUDIENCES_TO_API = gql`
  mutation saveAudiences($data: JSON!) {
    saveAudiences(data: $data)
  }
`;

export default SAVE_AUDIENCES_TO_API;
